/**
 * AutoKana ディレクティブ
 *
 * 使い方:
 * 1. 日本語入力フィールドに id="xxx" を設定
 * 2. カナフィールドに id="xxx-kana" を設定
 * 3. 日本語フィールドに v-autokana:xxx を追加（引数はIDと同じにする）
 *
 * 例:
 * <input id="company-name" v-model="form.name" v-autokana:company-name />
 * <input id="company-name-kana" v-model="form.nameKana" />
 *
 * 注意:
 * - カナフィールドが見つからない場合は何も起きません（エラーは出ません）
 * - グローバル登録する場合は main.js で app.use(AutoKanaPlugin) を実行
 * - コンポーネント内で登録する場合は directives: { autokana: vAutokana } を定義
 */
import * as AutoKana from 'vanilla-autokana'

export const vAutokana = {
  mounted(el, binding) {
    // 元のIDを取得してカナ用IDを生成
    const kanaId = `${el.id}-kana`

    // 次の処理をDOMが完全に描画された後に実行
    setTimeout(() => {
      // カナフィールドを検索
      let kanaEl = document.getElementById(kanaId)

      // カナ要素が見つからなければ静かに終了
      if (!kanaEl) {
        return
      }

      try {
        // 空文字で初期化
        if (!el.value) el.value = ''
        if (!kanaEl.value) kanaEl.value = ''

        const autokana = AutoKana.bind('#' + el.id, '#' + kanaId, {
          katakana: true,
        })
        el._autokana = autokana

        // 入力ハンドラを追加
        el.addEventListener('input', () => {
          try {
            // 元の値を保持
            const originalKanaValue = kanaEl.value

            // 一時的にクリアしてフリガナを取得
            kanaEl.value = ''
            const furigana = autokana.getFurigana()

            // フリガナが有効な場合のみ更新
            if (furigana !== null && furigana !== undefined && furigana.trim() !== '') {
              kanaEl.value = furigana
              kanaEl.dispatchEvent(new Event('input', { bubbles: true }))
            } else {
              // フリガナが取得できない場合は元の値を復元
              kanaEl.value = originalKanaValue
            }
          } catch (error) {
            // エラー時は静かに処理を続行
          }
        })
      } catch (error) {
        // 初期化エラー時は静かに処理を続行
      }
    }, 50)
  },

  // アンマウント時の cleanup
  unmounted(el) {
    if (el._autokana) {
      delete el._autokana
    }
  },
}

// ディレクティブのプラグイン化
export default {
  install(app) {
    app.directive('autokana', vAutokana)
  },
}
